export default __webpack_public_path__ + "locales/sr-Cyrl-RS/FilesSettings.json?hash=956df3215c332a2a876b80fd077b2f15";